import { render, staticRenderFns } from "./select-brand.vue?vue&type=template&id=2d38e920&scoped=true&"
import script from "./select-brand.vue?vue&type=script&lang=js&"
export * from "./select-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38e920",
  null
  
)

export default component.exports